import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Handler from '../../Handler';

export const DatePicker = (props) => {
  const { value, onChange, meta, onEnter, min, max } = props;
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  let minDate = min ? min.replaceAll('.', '-') : null;
  let maxDate = max ? max.replaceAll('.', '-') : null;

  const onChangeInput = (e) => {
    onChange(e.target.value, meta.key);
  };

  const buildInputClassname = () => {
    if (error) {
      return 'error';
    } else {
      return null;
    }
  };

  const renderRequired = () => {
    if (meta && meta.required) {
      if (meta.className === 'point') {
        return <div className='ico required'></div>;
      } else {
        return <span className='text-red-600'>*</span>;
      }
    }
  };
  console.log('picker meta', meta);
  console.log('picker value', value);

  return (
    <article
      className={Handler.BuildArticleClassname('form-date-picker', meta)}
      style={meta && meta.style ? { ...meta.style } : {}}
    >
      {meta.label && (
        <header className='justify-start'>
          <span>{t(meta.label)}</span>
          {renderRequired()}
        </header>
      )}
      <div className='input__box'>
        <input
          className={buildInputClassname()}
          placeholder={t('DATE_PLACEHOLDER')}
          disabled={meta.disabled || meta.readOnly}
          value={value || ''}
          onChange={onChangeInput}
          type={'date'}
          min={minDate}
          max={maxDate}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (onEnter) {
                onEnter();
              }
            }
          }}
        ></input>
      </div>
    </article>
  );
};
